<div class="h2 content-title text-center p-3">Önkormányzati dokumentumok</div>

<div class="content my-3 col-lg-10 mx-auto">
  <ng-container *ngFor="let type of documents">
    <p
      *ngIf="type.description"
      class="mx-auto document-description"
      [innerHtml]="type.description"
    ></p>
    <app-accordion
      [title]="type.typeName"
      [defaultOpened]="opened === type.folderName"
    >
      <ng-container *ngIf="type.years && type.years.length > 0">
        <app-accordion *ngFor="let year of type.years" [title]="year.year">
          <ng-container *ngIf="year.months && year.months.length > 0">
            <app-accordion
              *ngFor="let month of year.months"
              [title]="month.name"
            >
              <ul class="my-3">
                <li
                  *ngFor="let doc of month.docs"
                  (click)="
                    download(
                      doc.name,
                      type.folderName,
                      year.year,
                      month.number,
                      doc.id
                    )
                  "
                >
                  <i class="fas fa-file-pdf mr-3"></i>{{ doc.name }}
                </li>
              </ul>
            </app-accordion>
          </ng-container>
          <ng-container *ngIf="!year.months || year.months.length === 0">
            <p>Nincs ide tartozó dokumentum</p>
          </ng-container>
        </app-accordion>
      </ng-container>
      <ng-container *ngIf="type.subCategories && type.subCategories.length > 0">
        <app-accordion
          *ngFor="let cat of type.subCategories"
          [title]="cat.name"
        >
          <ul class="my-3">
            <ng-container *ngFor="let doc of cat.docs">
              <li
                *ngIf="!doc.link"
                (click)="
                  download(doc.name, null, null, null, null, null, doc.path)
                "
              >
                <i class="fas fa-file-pdf mr-3"></i>{{ doc.name }}
              </li>
              <li *ngIf="doc.link">
                <a [href]="doc.link">{{ doc.name }}</a>
              </li>
            </ng-container>
          </ul>
        </app-accordion>
      </ng-container>
      <ng-container *ngIf="type.docs && type.docs.length > 0"></ng-container>
      <ul class="my-3">
        <li
          *ngFor="let doc of type.docs"
          (click)="
            download(doc.name, null, null, null, null, doc.ext, doc.path)
          "
        >
          <i
            [ngClass]="
              doc.ext && doc.ext === '.xls'
                ? 'fa-file-excel'
                : doc.ext && (doc.ext === '.doc' || doc.ext === '.docx')
                ? 'fa-file-word'
                : 'fa-file-pdf'
            "
            class="fas mr-3"
          ></i
          >{{ doc.name }}
        </li>
      </ul>
      <ng-container
        *ngIf="
          (!type.years || type.years.length === 0) &&
          (!type.subCategories || type.subCategories.length === 0) &&
          (!type.docs || type.docs.length === 0)
        "
      >
        <p>Nincs ehhez kapcsolódó dokumentum</p>
      </ng-container>
    </app-accordion>
  </ng-container>
</div>
